if (!customElements.get('cart-line-note')) {
  function normalizeLineProperties(raw) {
    if (!raw || typeof raw !== 'object') return {};

    if (Array.isArray(raw)) {
      return raw.reduce((acc, entry) => {
        if (!entry || typeof entry !== 'object') return acc;
        if ('name' in entry && 'value' in entry) {
          acc[entry.name] = entry.value;
        } else if ('first' in entry && 'last' in entry) {
          acc[entry.first] = entry.last;
        } else if (Array.isArray(entry) && entry.length >= 2) {
          acc[entry[0]] = entry[1];
        } else {
          Object.assign(acc, entry);
        }
        return acc;
      }, {});
    }

    return { ...raw };
  }

  class CartLineNote extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-cart-line-note-trigger]')?.addEventListener('click', () => {
        const modalId = this.querySelector('modal-opener')?.getAttribute('data-modal');
        const modal = modalId && document.querySelector(modalId);
        const field = modal?.querySelector('[data-cart-line-note-field]');
        if (field) field.value = this.dataset.currentNote || '';
      });
    }

    getPropertiesForUpdate(noteValue) {
      let properties = {};
      try {
        properties = normalizeLineProperties(JSON.parse(this.dataset.lineProperties || '{}'));
      } catch (e) {
        properties = {};
      }

      const trimmed = (noteValue || '').trim();
      if (trimmed) {
        properties.Opmerking = trimmed;
      } else {
        delete properties.Opmerking;
      }

      return properties;
    }
  }

  customElements.define('cart-line-note', CartLineNote);

  if (!document.documentElement.dataset.cartLineNotesBound) {
    document.documentElement.dataset.cartLineNotesBound = 'true';

    document.addEventListener('click', (e) => {
      const saveBtn = e.target.closest('[data-cart-line-note-save]');
      if (!saveBtn) return;

      const modal = saveBtn.closest('modal-dialog.cart-line-note-modal');
      if (!modal) return;

      const noteEl = modal.openedBy?.closest('cart-line-note');
      if (!noteEl) return;

      const field = modal.querySelector('[data-cart-line-note-field]');

      const cartItems = noteEl.closest('cart-items');
      if (!cartItems?.updateLineProperties) return;

      cartItems
        .updateLineProperties(
          noteEl.dataset.lineIndex,
          parseInt(noteEl.dataset.lineQuantity, 10),
          noteEl.getPropertiesForUpdate(field?.value || ''),
          e,
          {
            lineKey: noteEl.dataset.lineKey,
            variantId: noteEl.dataset.variantId,
          }
        )
        .then((ok) => {
          if (ok) modal.hide();
        });
    });
  }
}
